import { render, staticRenderFns } from "./WebcamDialog.vue?vue&type=template&id=126fc422"
import script from "./WebcamDialog.vue?vue&type=script&lang=js"
export * from "./WebcamDialog.vue?vue&type=script&lang=js"
import style0 from "./WebcamDialog.vue?vue&type=style&index=0&id=126fc422&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports